import { useEffect, useState } from 'react'

type ToranjaTheme = 'pf-light' | 'pf-dark'

export const useToranjaTheme = () => {
  const [theme, setTheme] = useState<ToranjaTheme>(() => {
    const html = document.documentElement
    const attr = html.getAttribute('toranja-theme')
    if (attr === 'pf-dark' || attr === 'pf-light') {
      return attr
    }
    return 'pf-light'
  })

  useEffect(() => {
    const html = document.documentElement
    html.setAttribute('toranja-theme', theme)
  }, [theme])

  const setToranjaTheme = (newTheme: ToranjaTheme) => {
    setTheme(newTheme)
  }
  return { theme, setToranjaTheme }
}
